import React, { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import SubscriptionForm from "./Stripe/SubscriptionForm";
import CheckoutForm from "./Stripe/CheckoutForm";
import "./scss/style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import ResetPasswordPage from "./ForgotPassword/ForgotPassword";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

function App() {
  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("token");
  console.log(token);

  const isForgotPassword = queryParams.get("isForgotPassword");
  const [clientSecret, setClientSecret] = useState("");
  const [price_id, setPrice_id] = useState("");
  const [subscription_id, setSubscription_id] = useState("");
  const [Loader, setLoader] = useState(false);
  const [planId, setPlanId] = useState("");

  useEffect(() => {
    if (token) {
      setLoader(true);
      // First fetch subscription plans dynamically, then create subscription
      fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/get-subscription`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "x-platform": "web",
          },
        }
      )
        .then((res) => res.json())
        .then((planData) => {
          if (planData.Status === 200 && planData.Result && planData.Result.length > 0) {
            const fetchedPlanId = planData.Result[0]._id;
            setPlanId(fetchedPlanId);
            return fetch(
              `${process.env.REACT_APP_API_BASE_URL}/api/create-subscription`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                  planId: fetchedPlanId,
                }),
              }
            );
          } else {
            throw new Error("No subscription plans found");
          }
        })
        .then((res) => res.json())
        .then((data) => {
          setLoader(false);
          if (data) {
            setClientSecret(data.result.clientSecret);
            setPrice_id(data.result.price_id);
            setSubscription_id(data.result.subscriptionId);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.error("Error setting up subscription:", err);
        });
    }
  }, []);

  const options = {
    clientSecret: clientSecret,
    appearance: {
      theme: "stripe",
      rules: {
        ".TabLabel": {
          fontWeight: "500",
        },
        ".TermsText": {
          fontSize: "0px",
          display: "none",
          lineHeight: "0px",
        },
      },
    },
  };

  console.log(isForgotPassword);

  return (
    <>
      {Loader ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
      ) : (
        <>
          {isForgotPassword ? (
            <ResetPasswordPage />
          ) : (
            <div>
              {clientSecret !== "" && (
                <Elements stripe={stripePromise} options={options}>
                  <CheckoutForm
                    price_id={price_id}
                    subscriptionId={subscription_id}
                    planId={planId}
                  />
                </Elements>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
}

export default App;
